import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { UniverseComponent } from 'src/domains/common/universes';
import { MiniCasinoBtn } from 'src/domains/casino/webview/CasinoGames/mini-games/mini-games-grid/grid-footer/ShowMoreButton.style';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

interface ShowMoreButtonPropsType {
    isGamesListExtended: boolean;
    toggleExtendGamesList: () => void;
    dataTest?: string;
}

export const ShowMoreButton = observer(
    'ShowMoreButton',
    ({ dataTest, isGamesListExtended, toggleExtendGamesList }: ShowMoreButtonPropsType) => {
        const common = useCommon();
        const starRouter = StarRouter.get(common);
        const configState = ConfigComponents.get(common).config;

        if (configState.componentVariants.miniGamesVariant === DefaultComponentVariantType.SECONDARY) {
            return (
                <UniverseComponent>
                    {(universeModule): React.ReactElement => (
                        <MiniCasinoBtn
                            appearance={universeModule.miniCasinoButtons.showMoreButton}
                            dataTest={dataTest ?? 'mini-games-see-all-button'}
                            onClick={(): void => starRouter.redirectToCasinoPage()}
                            size='small'
                        >
                            <I18n
                                langKey='casino.mini-games.show-all-button'
                                defaultText='Show All'
                            />
                        </MiniCasinoBtn>
                    )}
                </UniverseComponent>
            );
        }

        return (
            <UniverseComponent>
                {(universeModule): React.ReactElement => (
                    <MiniCasinoBtn
                        appearance={universeModule.miniCasinoButtons.showMoreButton}
                        dataTest={dataTest ?? 'mini-games-see-more-button'}
                        onClick={toggleExtendGamesList}
                        size='small'
                    >
                        {isGamesListExtended ? (
                            <I18n
                                langKey='casino.mini-games.see-less-button'
                                defaultText='Show Less'
                            />
                        ) : (
                            <I18n
                                langKey='casino.mini-games.see-more-button'
                                defaultText='See More'
                            />
                        )}
                    </MiniCasinoBtn>
                )}
            </UniverseComponent>
        );
    }
);
